import React, { useContext } from "react";
import { PropsContext } from "../../context/PropsContext";

const ConfirmDeleteProp = ({ prop, handleCancel }) => {
  const { deleteProp } = useContext(PropsContext);

  const handleDelete = () => {
    deleteProp(prop);
  };

  return (
    <div>
      <p>¿Estás seguro que deseas eliminar el prop {prop.name}?</p>
      <p>Esta acción NO puede deshacerse.</p>
      <div className="row">
        <div className="col-6">
          <button onClick={handleCancel} className="btn text-muted w-100">
            Cancelar
          </button>
        </div>
        <div className="col-6">
          <button onClick={handleDelete} className="btn btn-danger w-100">
            Eliminar
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmDeleteProp;
